/*global console, document, $, jQuery */
(function ($) {
    'use strict';

    function log(d) {
        //console.log(d);
    }

    //    $(document).ready(function () {
    $.fn.pagination = function (options) {
        //        alert('prout');
        var paginationContainer = this,
            itemsPerPage,
            itemsToPaginate,
            defaults,
            settings,
            i,
            numberOfPaginationLinks;

        log(paginationContainer);

        defaults = {
            itemsPerPage: 10
        };
        settings = {};
        $.extend(settings, defaults, options);
        itemsPerPage = settings.itemsPerPage;
        itemsToPaginate = $(settings.itemsToPaginate);
        numberOfPaginationLinks = Math.ceil((itemsToPaginate.length / itemsPerPage));
        log(numberOfPaginationLinks);

        // Création de list dans la div ciblée
        $('<ul></ul>').prependTo(paginationContainer);
        $('.pagination').find('li:first-child').removeClass('active');
        // Boucle qui créer des li
        for (i = 0; i < numberOfPaginationLinks; i += 1) {
            paginationContainer.find('ul').append('<li>' + (i + 1) + '</li>');
        }
        $('.pagination').find('li:first-child').addClass('active');
        itemsToPaginate.filter(':gt(' + (itemsPerPage - 1) + ')').hide();
        paginationContainer.find('ul li').click(function () {
            var itemsToHide,
                linkNumber,
                itemsToShow,
                $this = $(this);
            $this.addClass(settings.activeClass);
            $this.siblings().removeClass(settings.activeClass);
            linkNumber = $this.text();

            itemsToHide = itemsToPaginate.filter(':lt(' + ((linkNumber - 1) * itemsPerPage) + ')');
            $.merge(itemsToHide, itemsToPaginate.filter(':gt(' + ((linkNumber * itemsPerPage) - 1) + ')'));
            itemsToHide.hide();
            itemsToShow = itemsToPaginate.not(itemsToHide);
            itemsToShow.show();
        });
    };
    //    });

}(jQuery));

/*global console, document, $, jQuery */
(function ($) {
    'use strict';
    $(document).ready(function () {
        // Appel du plugin
        $('.pagination').pagination({
            itemsToPaginate: ".news-items",
            activeClass: 'active'
        });
    });

}(jQuery));
/*(function ($) {
    'use strict';
    $(document).ready(function () {
        $('body').on('click', '.news-item h3', function(e){
            e.stopPropagation();
            $(this).next().slideToggle("fast");
            $(this).toggleClass('active');
            $('.news__desc').not($(this).next()).slideUp("fast");
            $('.news-item h3').not(this).removeClass('active');
        });
    });

}(jQuery));*/
